<template>
  <div id="solutionwrp">
    <div class="solution">
      <div class="topview">
        <div class="title">数智场馆</div>
        <div class="desc">赋能青少年活动中心、科技馆等数智治理能力</div>
        <div class="menu" @click="scrollBtm">立即咨询 <i class="iconfont icon-enter enter" /></div>
      </div>
    </div>
    <div class="stepone">
      <div class="title">传统青少年活动中心面临的挑战</div>
      <div class="itemwrap">
        <div class="showitem">
          <img class="icon" src="https://qutanlu-prod.oss-cn-shenzhen.aliyuncs.com/newWebsite/soluvenue/icon1.png" alt="">
          <p class="desc" >学生家长流失严重</p>
          <p class="con" >以奈尔宝为代表的专业少儿活动中心提供更丰富好玩的项目，导致参与数人数逐年下降</p>
        </div>
        <div class="showitem">
          <img class="icon" src="https://qutanlu-prod.oss-cn-shenzhen.aliyuncs.com/newWebsite/soluvenue/icon2.png" alt="">
          <p class="desc" >场馆软硬件跟不上</p>
          <p class="con" >设施老旧，体验功能单一，没有数字化管理手段；统计和协调基本还是靠人工为主，工作效率低</p>
        </div>
        <div class="showitem">
          <img class="icon" src="https://qutanlu-prod.oss-cn-shenzhen.aliyuncs.com/newWebsite/soluvenue/icon3.png" alt="">
          <p class="desc" >数字管理能力缺失，决策无依旧</p>
          <p class="con" >日常运营无数据记录与沉淀，学生无成长档案，管理决策拍脑袋，改进效果差</p>
        </div>
      </div>
    </div>
    <div class="steptwo">
      <div class="steptwo_l">
        <div class="title">
          解决方案介绍<span>/数智场馆</span>
        </div>
        <div class="con">
          <span :class="currentIndex == index ? 'active' : 'clickitem'" @click="handleItemClick(index)" v-for="(item,index) of clickdata" :key="index">{{item}}</span>
        </div>
      </div>
      <div class="steptwo_r">
        <img class="img" :src="currentimg" alt="">
      </div>
    </div>
    <div class="stepthree">
      <div class="stepthree_l">
        <img class="img" src="https://qutanlu-prod.oss-cn-shenzhen.aliyuncs.com/newWebsite/soluvenue/example.png" alt="">
      </div>
      <div class="stepthree_r">
        <div class="title">
          方案示例<span>/青少年活动中心</span>
        </div>
        <div class="desc">从用户手机到场馆智能软硬件再到管理人员云端，全面建设在数字时代管理，运营、销售、产品，数据闭环。</div>
      </div>
    </div>
    <div class="bottomview">
      <div class="btmcon">
        <span class="touch">联系我们</span>
        <div class="btntip">或留下您的联系方式，我们将有专人与您联系</div>
        <input class="inp" type="text" :placeholder="usernamePlace" :class="{redColor: usernamePlace != '姓名'}" v-model="username">
        <input class="inp" type="text" :placeholder="phonePlace" :class="{redColor: phonePlace != '电话'}" v-model="phone">
        <div class="apply" @click="handleSubmit">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import { mail_send } from '../utils/api'
export default {
  data () {
    return {
      currentIndex: 0,
      currentimg:'https://qutanlu-prod.oss-cn-shenzhen.aliyuncs.com/newWebsite/soluvenue/plan1.png',
      clickdata: [
        '解决信息传达问题，加深用户理解',
        '预约、入馆更方便快捷',
        '场馆管理高效，降低成本',
        '数据支撑运营、管理决策',
        '多样增值服务，让家长、小朋友更有收获',
        '提供互联网运营方式，提升影响力'
      ],
      username: '',
      phone: '',
      usernamePlace: '姓名',
      phonePlace: '电话'
    }
  },
  methods: {
    handleItemClick(index) {
      this.currentIndex = index
      this.currentimg = index == 0 ? 'https://qutanlu-prod.oss-cn-shenzhen.aliyuncs.com/newWebsite/soluvenue/plan1.png' : 
                        index == 1 ? 'https://qutanlu-prod.oss-cn-shenzhen.aliyuncs.com/newWebsite/soluvenue/plan2.png' : 
                        index == 2 ? 'https://qutanlu-prod.oss-cn-shenzhen.aliyuncs.com/newWebsite/soluvenue/plan3.png' : 
                        index == 3 ? 'https://qutanlu-prod.oss-cn-shenzhen.aliyuncs.com/newWebsite/soluvenue/plan4.png' : 
                        index == 4 ? 'https://qutanlu-prod.oss-cn-shenzhen.aliyuncs.com/newWebsite/soluvenue/plan5.png' : 
                        index == 5 ? 'https://qutanlu-prod.oss-cn-shenzhen.aliyuncs.com/newWebsite/soluvenue/plan6.png' : ''
    },
    scrollBtm () {
      window.scrollTo(0,2000);
    },
    handleSubmit() {
      if(!this.username) {
        this.usernamePlace = '请填写姓名'
        return
      }
      if (!this.phone) {
        this.phonePlace = '请填写电话'
        return
      }
      mail_send({
        source: '智数场馆',
        content: this.username + ';' + this.phone
      }).then(res => {
        if(res.status == '200') {
          this.$message.success('信息已提交成功')
        }
      })
      // axios.post('http://ask.qutanlu.com/app/web/mail_send', {
      //   source: '智数场馆',
      //   content: this.username + ';' + this.phone
      // }, {
      //   headers: {
      //     changeOrigin: true
      //   }
      // }).then(res => {
      //   if(res.status == '200') {
      //     this.$message.success('信息已提交成功')
      //   }
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.solution{
  height: 663px;
  background: url('https://qutanlu-prod.oss-cn-shenzhen.aliyuncs.com/newWebsite/soluvenue/banner.png');
  background-size: cover;
  .topview{
    width: 1220px;
    margin: 0 auto;
    clear: both;
    overflow: hidden;
    .title{
      font-size: 44px;
      font-weight: 600;
      color: #121212;
      margin-top: 240px;
    }
    .desc{
      font-size: 20px;
      font-weight: 500;
      color: #121212;
      margin-top: 18px;
    }
    .menu{
      margin-top: 60px;
      width: 185px;
      height: 62px;
      background: #444444;
      border-radius: 31px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: 500;
      color: #FFFFFF;
      cursor: pointer;
      .enter{
        font-size: 13px;
        margin-left: 16px;
        color: #fff;
      }
    }
  }
}
  .stepone{
    width: 1220px;
    margin: 60px auto 160px;
    .title{
      font-size: 36px;
      font-weight: 600;
      color: #121212;
    }
    .itemwrap{
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      .showitem{
        width: 320px;
        margin-top: 61px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-flow: column;
        .icon{
          // width: 64px;
          height: 64px;
        }
        .desc{
          font-size: 20px;
          font-weight: 600;
          color: #121212;
          margin-top: 21px;
        }
        .con{
          font-size: 14px;
          color: #444444;
          margin-top: 10px;
          text-align: center;
        }
      }
    }
  }
  .steptwo{
    width: 1220px;
    margin: 0 auto 160px;
    display: flex;
    justify-content: space-between;
    .steptwo_l{
      margin-right: 80px;
      flex: 1;
      .title{
        font-size: 36px;
        font-weight: 600;
        color: #121212;
        margin-top: 22px;
        span{
          font-size: 20px;
          font-weight: 500;
          color: #121212;
          padding-left: 10px;
        }
      }
      .con{
        margin-top: 40px;
        display: flex;
        flex-wrap: wrap;
        .clickitem,.active{
          width: 100%;
          font-size: 16px;
          color: #121212;
          padding: 20px;
          background: #fff;
          border-radius: 39px;
          cursor: pointer;
        }
        .active{
          background: #F8F6F6;
        }
      }
    }
    .steptwo_r{
      .img{
        width: 714px;
        height: 463px;
      }
    }
  }
  .stepthree{
    width: 1220px;
    margin: 0 auto 160px;
    display: flex;
    justify-content: space-between;
    .stepthree_l{
      margin-right: 80px;
      .img{
        width: 680px;
        height: 400px;
      }
    }
    .stepthree_r{
      flex: 1;
      .title{
        font-size: 36px;
        font-weight: 600;
        color: #121212;
        margin-top: 22px;
        span{
          font-size: 20px;
          font-weight: 500;
          color: #121212;
          padding-left: 10px;
        }
      }
      .desc{
        margin-top: 60px;
        font-size: 16px;
        font-weight: 500;
        color: #444444;
      }
      .codewrap{
        display: flex;
        align-items: center;
        margin-top: 62px;
        .codeimg{
          width: 110px;
          height: 110px;
        }
        .tip{
          margin-left: 20px;
          font-size: 16px;
          font-weight: 500;
          color: #121212;
        }
      }
    }
  }
  .bottomview{
    background-image: url('https://qutanlu-prod.oss-cn-shenzhen.aliyuncs.com/newWebsite/soluvenue/touch.png');
    background-size: 100%;
    height: 456px;
    .btmcon{
      width: 1220px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      flex-flow: column;
      align-items: center;
      .touch{
        font-size: 36px;
        font-weight: 500;
        color: #FFFFFF;
        margin-top: 60px;
      }
      .btntip{
        margin-top: 10px;
        margin-bottom: 40px;
        font-size: 16px;
        font-weight: 500;
        color: #FFFFFF;
      }
      .inp{
        width: 507px;
        height: 54px;
        font-size: 14px;
        color: #999999;
        text-indent: 20px;
        margin-bottom: 12px;
        background: #fff;
        border-radius: 4px; 
      }
      .redColor::-webkit-input-placeholder {
        color: red;
      }
      .redColor::-moz-placeholder{   /* Mozilla Firefox 19+ */
        color:red;
      }
      .redColor:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
        color:red;
      }
      .redColor:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
        color:red;
      }
      .apply{
        margin-top: 30px;
        width: 148px;
        height: 54px;
        background: #FFFFFF;
        border-radius: 4px;
        text-align: center;
        line-height: 54px;
        font-size: 14px;
        font-weight: 600;
        color: #121212;
        cursor: pointer;
      }
    }
  }
</style>
